<script>
import { openFeedbackForm } from '../feedbackform';
import { __ } from '../utils/i18n';

let appear = false;

function closeAlert() {
  appear = !appear;
}

</script>

{#if appear}
<div class="alert" role="alert">
  <h3>
    Shape Your L.A. is updated!
  </h3>
  <span>
    Lists of elected officials reflect November 2022 election results, and city services information is included for all 88 L.A. County cities (and unincorporated areas too).
    <a aria-label="{__('Open feedback form')}" href="#" on:click={(e)=> {openFeedbackForm()}}>
      Tell us what you’d like to see next.
    </a>
  </span>
  <div class="close" tabindex="0" aria-label="Select to close" role="button" 
        on:click={closeAlert}
        on:keypress={(e)=>{if (e.key === "Enter") closeAlert()}}
    >
    <svg class="icon icon-close" aria-hidden="false" aria-label="X icon">
      <use href="#icon-close"/>
    </svg>
  </div>
</div>
{/if}

 